(() => {
  const page = document.getElementById('MguTeaser');
  if (!page) return;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reveals = [...page.querySelectorAll('.mgu-teaser__reveal')];
  if (!reduceMotion.matches && 'IntersectionObserver' in window) {
    page.classList.add('mgu-teaser--motion');
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .08, rootMargin: '0px 0px -20px 0px' });
    reveals.forEach((node) => observer.observe(node));
    requestAnimationFrame(() => {
      reveals.filter((node) => node.getBoundingClientRect().top < window.innerHeight).forEach((node) => node.classList.add('is-visible'));
    });
  }

  const bands = [...page.querySelectorAll('.mgu-teaser__parallax')];
  const progress = page.querySelector('.mgu-teaser__progress');
  let ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const total = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
      progress.style.transform = `scaleX(${Math.min(1, Math.max(0, window.scrollY / total))})`;
      if (!reduceMotion.matches && window.innerWidth > 700) {
        bands.forEach((band) => {
          const rect = band.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          const displacement = Math.max(-35, Math.min(35, (window.innerHeight / 2 - (rect.top + rect.height / 2)) * .055));
          band.style.setProperty('--t-parallax', `${displacement}px`);
        });
      }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  onScroll();

  const interestSelect = page.querySelector('[data-teaser-interest-select]');
  if (interestSelect) {
    page.querySelectorAll('[data-teaser-interest]').forEach((link) => {
      link.addEventListener('click', () => {
        interestSelect.value = link.dataset.teaserInterest;
      });
    });
  }

  const success = page.querySelector('.mgu-teaser__form-success');
  if (success) {
    success.scrollIntoView({ block: 'center' });
    success.focus({ preventScroll: true });
  }
})();
